module.exports = __webpack_public_path__ + "static/media/zadania-matematyczne-klasa-5-m2.8818bb3d.jpg";